import { apiType } from "./apiType";

export interface IApplicantCommentCreatePayload {
  text: string;
  applicant_id: number;
}

/** @deprecated Use IApplicantCommentCreatePayload */
export interface ICommentStudentInfoCreatePayload {
  text: string;
  student_id: number;
}

export const commentsRequests = {
  createApplicantComment: async (payload: IApplicantCommentCreatePayload) => {
    try {
      return await apiType.main.post<unknown>(`/comments/applicant/create`, payload);
    } catch (error) {
      console.log("This is createApplicantComment error:", error);
      return null;
    }
  },
  deleteApplicantComment: async (commentId: number) => {
    try {
      return await apiType.main.delete<unknown>(`/comments/applicant/delete`, undefined, {
        params: { comment_id: commentId },
      });
    } catch (error) {
      console.log("This is deleteApplicantComment error:", error);
      return null;
    }
  },
  /** @deprecated Use createApplicantComment with applicant_id */
  createCommentsStudentInfo: async (payload: ICommentStudentInfoCreatePayload) =>
    commentsRequests.createApplicantComment({
      text: payload.text,
      applicant_id: payload.student_id,
    }),
  /** @deprecated Use deleteApplicantComment */
  deleteCommentsStudentInfo: async (commentId: number) => commentsRequests.deleteApplicantComment(commentId),
};
